import { render, staticRenderFns } from "./BienVivreMaGrossesse.vue?vue&type=template&id=c1b8c4ec&scoped=true&"
import script from "./BienVivreMaGrossesse.vue?vue&type=script&lang=ts&"
export * from "./BienVivreMaGrossesse.vue?vue&type=script&lang=ts&"
import style0 from "./BienVivreMaGrossesse.vue?vue&type=style&index=0&id=c1b8c4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b8c4ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
